import React from 'react'
import DynamicItemViewPage from '../admin/DynamicItemViewPage'

interface IProjectQuickPreviewProps {
    projectId: number
}

export default function ProjectQuickPreview(props: IProjectQuickPreviewProps) {

    const { projectId } = props

    return <DynamicItemViewPage customId={projectId} customPage="projects" />
}